import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import Reference from './types/Reference';

export default class BN_MedPassDay extends DomainResource {
    static __className = 'BN_MedPassDay';

    __objectStructure = {
        location: Reference,
        dayKey: String,
        generatedOn: String,
        reconciledOn: String,
        attestedBy: Reference,
        attestedOn: String,
        expectedCount: Number,
        generatedCount: Number,
        administeredCount: Number,
        refusedCount: Number,
        notCoveredCount: Number,
        ownedCount: Number,
    };

    constructor(constructJson, className = 'BN_MedPassDay') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
